var _require = require('prettier/standalone'),
    join = _require.doc.builders.join;

var Parameter = {
  print: function print(_ref) {
    var node = _ref.node,
        path = _ref.path,
        _print = _ref.print;
    var doc = path.call(_print, 'typeName');
    doc = join(' ', [doc, node.storageLocation, node.typeName.stateMutability, node.name].filter(function (element) {
      return element;
    }));
    return doc;
  }
};
module.exports = Parameter;